<canvas id="canvasProductivity3" class="canvasProductivity canvasProductivity3" width="172" height="172"></canvas>